import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../../../routes';
import NavLinkListItem from '../../../Navigation/NavLinkListItem/NavLinkListItem';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        /* Important for height to be inforced because is a virtual list */
        height: '57px',
        overflow: 'hidden',
        borderBottom: `1px solid ${theme.palette.divider}`,
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
        },
    },
    primaryText: {
        color: theme.palette.text.primary,
    },
}));

interface Props {
    firstName: string;
    lastName: string;
    contactId: number;
    statusName: string | null;
}

export default function GroupContactsListItem({
    firstName,
    lastName,
    contactId,
    statusName,
}: Props) {
    const { classes } = useStyles();
    const location = useLocation();

    const [isSelected, setIsSelected] = React.useState<boolean>(false);

    React.useEffect(() => {
        setIsSelected(location.pathname.toLowerCase() === contactRoutes.setDetails(contactId));
    }, [location]);

    const contactName = `${firstName} ${lastName}`.trim();

    return (
        <NavLinkListItem
            pathname={contactRoutes.setDetails(contactId)}
            selected={isSelected}
            className={classes.root}
        >
            <ListItemAvatar>
                <Avatar variant="rounded">{contactName.slice(0, 1)}</Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={contactName}
                primaryTypographyProps={{
                    color: 'textPrimary',
                    noWrap: true,
                }}
                secondary={statusName || 'No Status'}
                secondaryTypographyProps={{
                    color: 'textSecondary',
                    noWrap: true,
                }}
            />
        </NavLinkListItem>
    );
}
